export default __webpack_public_path__ + "static/media/abonament.85e64f5e.png";